<!--
  - Copyright (c) 2021 brightlamp
  -->

<template>
    <MessageCenter adminMode="true" />
</template>

<script>
    import MessageCenter from '@/views/account/message-center-dashboard';

    export default
    {
        name: 'message-center-admin-dashboard',
        components:
        {
            MessageCenter
        },
    };
</script>

<style scoped>
</style>